import suddenMoneyImg from 'assets/images/suddenMoney.jpg';
import suddenMoneyOverview from 'assets/images/booksOverview/suddenMoney.png';

import { FLIP_BOOK, GIFT_BOOK, FLIP_BOOKS } from '../const';

import { getFlipBookPurchases } from './utils';

const suddenMoney = {
  book: {
    id: 'ploetzlich-geld',
    format: FLIP_BOOKS,
    title: 'All at once or in stages',
    subtitle: 'What should you do if you want to invest a large sum of money',
    videos: 'Erwin W. Heri, Alexandra Janssen, Patrick Eugster',
    layoutAndProduction: 'Hanspeter Frey',
    scope: { pages: 17, videos: 13 },
    price: [0, 0],
    introductions: ['If you receive a life insurance payout'],
    image: suddenMoneyImg,
    overviewImg: suddenMoneyOverview,
  },
  bookIds: [42, 43],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [FLIP_BOOK, GIFT_BOOK],
  purchases: getFlipBookPurchases([0, 0], [42, 43]),
};

export default suddenMoney;
